import { account } from './theme.forms.account';
import { input } from './theme.forms.input';
import { label } from './theme.forms.label';

export const forms = {
  account,
  input,
  label,
};
